<div class="confirm-payment-container">
    <div class="d-flex justify-content-end close-icon">
        <i class="fa-light fa-times pointer-in" (click)="close()"></i>
    </div>

    <div class="d-grid">
        <div class="icon-check-confirm icon-failed">
            <i class="fa-light fa-circle-xmark"></i>
        </div>
        <p class="info-confirm">No se ha completado el pago</p>
        <p class="text-failed">No se ha realizado ningún cargo. Para intentarlo de nuevo, vuelve a elegir tus entradas.</p>

        <button class="btn btn-confirm-wahtsapp" (click)="retry()">
            {{ eventSlug ? 'Volver al evento' : 'Ver eventos' }}
        </button>
    </div>
</div>
